import {propertyInstructionMapper} from "./propertyInstructionMapper";

export const apartmentMapper = (data) => {
    return {
        id: data.id,
        name: data.name,
        beds: data.beds,
        sofaBeds: data.sofaBeds,
        extraBeds: data.extraBeds,
        mq: data.mq,
        numberOfBathroom: data.numberOfBathroom,
        apartmentTypologyId: data.apartmentTypologyId,
        apartmentCategoryId: data.apartmentCategoryId,
        icon: data.icon,
        visible: data.visible,
        cinCode: data.cinCode,
        cinCodeMissing: data.cinCodeMissing,

        descriptionIt: data.descriptionIt,
        descriptionEn: data.descriptionEn,

        // List of photos
        photos: data.apartmentPhotos ? data.apartmentPhotos.map(apartmentPhotoMapper) : [],

        // List of services
        serviceJoins: data.apartmentServiceJoins ? data.apartmentServiceJoins.map(apartmentServiceJoinMapper) : [],

        // List of property instructions
        propertyInstructions: data.propertyInstructions ? data.propertyInstructions.map(propertyInstructionMapper) : [],
    }
}

export const apartmentPhotoMapper = (data) => {
    return {
        id: data.id,
        orderPosition: data.orderPosition,
        imgSquare: data.imgSquare,
    }
}

export const apartmentServiceJoinMapper = (data) => {
    return {
        id: data.id,
        apartmentServiceId: data.apartmentServiceId,
        withFee: data.withFee,
    }
}